/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileCertification } from '../../models/profile-certification';

export interface AddProfileCertification$Params {

/**
 * ID of profile to which will be certification add
 */
  id: number;
  
    /**
     * Profile certification to save.
     */
    body: ProfileCertification
}

export function addProfileCertification(http: HttpClient, rootUrl: string, params: AddProfileCertification$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCertification>> {
  const rb = new RequestBuilder(rootUrl, addProfileCertification.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileCertification>;
    })
  );
}

addProfileCertification.PATH = '/rest/profile/{id}/certification';
